module.exports = __webpack_public_path__ + "img/decorador-title-aliados.a1e2f885.svg";